module.exports = ".no-bottom-border {\n  border-bottom: 0 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/alerts/components/alert/alert.component.scss
// module id = ./libs/chassis-core/src/app/alerts/components/alert/alert.component.scss
// module chunks = main